import { useState } from "react";

import { portexColor } from "@portex-pro/ui-components";
import clsx from "clsx";
import PortexDialog from "components/PortexDialog";
import Text from "components/Text";
import { useTranslation } from "react-i18next";
import { ModeQuotes, MODE_QUOTES } from "types/Mode";

import { useQuoteRequestSelector } from "../_store";

interface SelectModeTabPanelProps {
  selected: ModeQuotes;
  onSelect: (mode: ModeQuotes) => void;
}

const modeColors: Record<ModeQuotes, string> = {
  FTL: "text-green-600 border-green-600",
  LTL: "text-green-600 border-green-600",
  DRAYAGE: "text-green-600 border-green-600",
  FCL: "text-blue-600 border-blue-600",
  AIR: "text-purple-600 border-purple-600",
};

export const SelectModeTabPanel: React.FC<SelectModeTabPanelProps> = ({ selected, onSelect }) => {
  const { t } = useTranslation(["common", "quoteRequest"]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [modeToChangeTo, setModeToChangeTo] = useState<ModeQuotes>();
  const { quoteRequest: airQuoteRequest } = useQuoteRequestSelector((store) => store.quoteRequestSliceV2);

  const changeMode = (mode: ModeQuotes) => {
    if (!!airQuoteRequest.id && mode !== airQuoteRequest.mode) {
      setIsDialogOpen(true);
      setModeToChangeTo(mode);
    } else {
      onSelect(mode);
    }
  };

  return (
    <>
      <div className="max-w-[547px]">
        <div className="bg-[#edeef0] rounded-2xl p-1 flex items-center justify-center mb-6 w-full overflow-hidden">
          {MODE_QUOTES.map((mode) => (
            <button
              key={mode}
              onClick={() => changeMode(mode)}
              className={clsx(
                "font-bold text-lg flex-1 min-w-0 whitespace-nowrap mx-0.5 my-0.5 px-2 py-2 rounded-md border-2 transition-colors duration-150",
                selected === mode ? `${modeColors[mode]} bg-white` : "text-gray-900 border-transparent bg-[#edeef0]"
              )}
              type="button"
            >
              {mode}
            </button>
          ))}
        </div>
      </div>
      <PortexDialog
        open={isDialogOpen}
        customDialogWidth={"400px"}
        maxWidth="sm"
        title={t("common:changeMode")}
        onClose={() => setIsDialogOpen(false)}
        confirmButtonProps={{ style: { background: portexColor.red500 } }}
        onClickConfirm={() => {
          if (modeToChangeTo) {
            onSelect(modeToChangeTo);
          }
          setIsDialogOpen(false);
        }}
      >
        <div className="p-4">
          <Text size="small">{t("quoteRequest:changeMode_warning")}</Text>
        </div>
      </PortexDialog>
    </>
  );
};
